var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalbooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-TotalBooking"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 26
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TotalBooking",
    clipPath: "url(#clip-TotalBooking)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M7.689,16H2.5A2.5,2.5,0,0,1,0,13.5v-9A2.5,2.5,0,0,1,2.5,2H3V.5a.5.5,0,1,1,1,0V2h8V.5a.5.5,0,1,1,1,0V2h.5A2.5,2.5,0,0,1,16,4.5V9.044a5.968,5.968,0,0,0-1-.355V6H1v7.5A1.5,1.5,0,0,0,2.5,15H7.52a6,6,0,0,0,.168,1ZM13,3V5h2V4.5A1.5,1.5,0,0,0,13.5,3ZM4,3V5h8V3ZM2.5,3A1.5,1.5,0,0,0,1,4.5V5H3V3Zm4,11a.5.5,0,1,1,.5-.5A.5.5,0,0,1,6.5,14Zm-3,0a.5.5,0,1,1,.5-.5A.5.5,0,0,1,3.5,14Zm3-3a.5.5,0,1,1,.5-.5A.5.5,0,0,1,6.5,11Zm-3,0a.5.5,0,1,1,.5-.5A.5.5,0,0,1,3.5,11ZM9,10.53v0c0-.009,0-.018,0-.027a.5.5,0,0,1,.5-.5H9.53A6.071,6.071,0,0,0,9,10.528ZM12.5,8a.5.5,0,1,1,.5-.5A.5.5,0,0,1,12.5,8Zm-3,0a.5.5,0,1,1,.5-.5A.5.5,0,0,1,9.5,8Zm-3,0A.5.5,0,1,1,7,7.5.5.5,0,0,1,6.5,8Z",
    transform: "translate(3 3)",
    fill: "#410a8c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_826",
    "data-name": "Ellipse 826",
    transform: "translate(11 12)",
    fill: "none",
    stroke: "#410a8c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Setting",
    "data-name": "Iconly/Bold/Setting",
    transform: "translate(11.534 12.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Setting",
    transform: "translate(2.5 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8516",
    "data-name": "Path 8516",
    d: "M3.19,0a.672.672,0,0,1,.568.325.555.555,0,0,1,.086.331A.483.483,0,0,0,3.917.93a.616.616,0,0,0,.8.215.659.659,0,0,1,.9.237h0l.214.368a.633.633,0,0,1-.236.883.569.569,0,0,0-.2.78.483.483,0,0,0,.2.2.718.718,0,0,1,.258.247.63.63,0,0,1-.006.64h0l-.223.375a.655.655,0,0,1-.9.231.509.509,0,0,0-.281-.072.6.6,0,0,0-.59.568.646.646,0,0,1-.66.64H2.749a.646.646,0,0,1-.664-.64A.591.591,0,0,0,1.5,5.036a.5.5,0,0,0-.281.072A.675.675,0,0,1,.88,5.2a.666.666,0,0,1-.568-.325h0L.092,4.5a.623.623,0,0,1-.006-.64.661.661,0,0,1,.255-.247.51.51,0,0,0,.2-.2.573.573,0,0,0-.207-.78A.638.638,0,0,1,.1,1.751h0l.214-.368a.663.663,0,0,1,.9-.237.613.613,0,0,0,.8-.215A.483.483,0,0,0,2.086.656.557.557,0,0,1,2.175.325.685.685,0,0,1,2.74,0h.45ZM2.97,2.242a.882.882,0,1,0,0,1.764.882.882,0,1,0,0-1.764Z",
    transform: "translate(0)",
    fill: "#410a8c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalbooking);
export default __webpack_public_path__ + "static/media/totalbooking.2c99d84fd50f83e461ab10fe12b77267.svg";
export { ForwardRef as ReactComponent };